// extracted by mini-css-extract-plugin
export default {"banner2":"banner2___m42yI","content":"content___DW4ja"};